import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo en beschrijving */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img
                src="https://static.readdy.ai/image/1c53e264fa16b8cf25d5fb02610910c0/5f511fff67823575e4b070393f87a975.png"
                alt="HerStart logo"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-600 mb-4 max-w-md">
              Een nieuwe start voor jongeren die hun weg terugvinden naar het onderwijs. 
              Wij begeleiden thuiszittende jongeren met empathie en deskundigheid.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://wa.me/31616708612"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-green-500 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a href="mailto:info@herstart.nl" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Snelle links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Snelle links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/over-herstart" className="text-gray-600 hover:text-orange-500 transition-colors cursor-pointer">
                  Over HerStart
                </Link>
              </li>
              <li>
                <Link to="/onze-aanpak" className="text-gray-600 hover:text-orange-500 transition-colors cursor-pointer">
                  Onze Aanpak
                </Link>
              </li>
              <li>
                <Link to="/trainingen" className="text-gray-600 hover:text-orange-500 transition-colors cursor-pointer">
                  Trainingen
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-orange-500 transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Contact
            </h3>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-600">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:info@herstart.nl" className="hover:text-orange-500 transition-colors">
                  info@herstart.nl
                </a>
              </li>
              <li className="flex items-center text-gray-600">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+31616708612" className="hover:text-orange-500 transition-colors">
                  +31 6 16708612
                </a>
              </li>
              <li className="flex items-center text-gray-600">
                <i className="ri-whatsapp-line mr-2 text-green-500"></i>
                <a
                  href="https://wa.me/31616708612"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-green-500 transition-colors"
                >
                  WhatsApp ons
                </a>
              </li>
              <li className="flex items-center text-gray-600">
                <i className="ri-map-pin-line mr-2"></i>
                Nederland
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">
              © 2026 HerStart. Alle rechten voorbehouden.
            </p>
            <div className="mt-4 md:mt-0 flex items-center gap-1 text-sm text-gray-500">
              <span>Made with</span>
              <i className="ri-heart-fill text-red-500 text-base"></i>
              <span>by</span>
              <a
                href="https://www.designkings.nl"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
              >
                Design Kings
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
